import {AppSettings } from './app.settings';
export class PaymentSettings{
    public static GET_COUNTRIES = `${AppSettings.BASE_URL}/api/utils/countries`;
    public static CONFIRM_PAYMENT = `${AppSettings.BASE_URL}/api/transaction/confirmTransaction`;
    public static PAYMENT_METHODS = `${AppSettings.BASE_URL}/api/utils/getLocalPaymentMethods`;
    public static CONFIRM_LOCAL_PAYMENT = `${AppSettings.BASE_URL}/api/transaction/localPayment`;
}